import { Icon, IconProps } from '@chakra-ui/react'

export const PrintIcon = (props: IconProps) => (
  <Icon viewBox="0 -960 960 960" boxSize={6} fill="currentColor" {...props}>
    <path d="M718-678H242v-162h476v162Zm21 185q12 0 21-9t9-21q0-12-9-21t-21-9q-12 0-21 9t-9 21q0 12 9 21t21 9Zm-81 313v-192H302v192h356Zm60 60H242v-176H80v-246q0-45.05 30.5-75.53Q141-648 186-648h588q45.05 0 75.53 30.47Q880-587.05 880-542v246H718v176Z" />
  </Icon>
)

export const PrintDisabledIcon = (props: IconProps) => (
  <Icon viewBox="0 -960 960 960" boxSize={6} fill="currentColor" {...props}>
    <path d="m813-61-95-95v36H242v-176H80v-246q0-45 30.5-75.5T186-648h40L61-813l43-43 752 752-43 43ZM302-180h356v-36L502-372H302v192Zm448-116L398-648h376q45 0 75.5 30.5T880-542v246H750Zm-92-382H368L206-840h512v162h-60Zm81 185q12 0 21-9t9-21q0-12-9-21t-21-9q-12 0-21 9t-9 21q0 12 9 21t21 9Z" />
  </Icon>
)
